import {
  ButtonGroupField,
  type ButtonGroupFieldProps,
  type Option,
} from "components/Forms/ButtonGroup";
import { groupByEnum } from "kubb";
import type React from "react";

interface CommonProps extends Omit<ButtonGroupFieldProps, "options"> {
  noneLabel?: string;
  includeAssetPositionGroup?: boolean;
  includeScheme?: boolean;
}

export default function GroupByRadioButtonGroupField(
  props: CommonProps,
): React.ReactElement {
  const { noneLabel, includeAssetPositionGroup, includeScheme, ...rest } =
    props;
  const options: Option[] = [
    { label: noneLabel || "NONE", value: groupByEnum.NONE },
    includeScheme && { label: " SCHEME", value: groupByEnum.SCHEME },
    includeAssetPositionGroup && {
      label: "GROUP",
      value: groupByEnum.GROUP_ALL,
    },
  ].filter((v) => {
    return v !== undefined && v !== false;
  });

  return <ButtonGroupField {...rest} options={options} />;
}
